import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Editorial } from "@/ui";
import { useMe } from "@/auth/oidc";
import { AuthLayout } from "./AuthLayout";
import { Field, OrDivider, SocialButtons } from "./fields";

export function Login() {
  const me = useMe();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");

  // Already signed in? Skip the form (e.g. landed here via a guard redirect).
  useEffect(() => {
    if (me.isAuthenticated) {
      const from = (loc.state as { from?: string } | null)?.from;
      nav(from && from !== "/login" ? from : "/today", { replace: true });
    }
  }, [me.isAuthenticated, loc.state, nav]);

  return (
    <AuthLayout
      eyebrow="welcome back"
      title="Sign in to your studio"
      subtitle="Pick up where you left off — your numbers have been keeping watch."
      momentLine={
        <>
          See <Editorial>what&rsquo;s working.</Editorial> Make what&rsquo;s next.
        </>
      }
      footer={
        <>
          New here?{" "}
          <Link to="/register" className="font-medium text-accent hover:text-accent-hover">
            Create an account
          </Link>
        </>
      }
    >
      <SocialButtons onSelect={() => me.signIn()} />
      <OrDivider />

      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          me.signIn(email.trim() || undefined);
        }}
      >
        <Field
          label="Email"
          type="email"
          name="email"
          autoComplete="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button variant="coral" size="lg" className="w-full" type="submit">
          Continue
        </Button>

        <p className="text-center text-[12px] leading-relaxed text-subtle">
          You&rsquo;ll finish signing in securely with aigen SSO.
        </p>
      </form>
    </AuthLayout>
  );
}
